<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25 3H11a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 20H11V5h14z"/><path d="M22 27H7V8a1 1 0 00-2 0v19a2 2 0 002 2h15a1 1 0 000-2z"/></svg>